import React from 'react'
import {
  BlogCreateDesignBannerContainer,
  BlogCreateDesignBannerImage,
  BlogCreateDesignBannerInfo,
  BlogCreateDesignBannerInfoDescription,
  BlogCreateDesignBannerInfoTitle,
  CreateDesignButton
} from './BlogCreateDesignBanner.styles'
import wrapperImage from '../../assets/blog/createDesignWrapper.png'
import { logEvent } from '../../utils/firebase'

export const BlogCreateDesignBanner = () => {
  return (
    <BlogCreateDesignBannerContainer>
      <BlogCreateDesignBannerImage src={wrapperImage} alt="" />
      <BlogCreateDesignBannerInfo>
        <BlogCreateDesignBannerInfoTitle>
          Start Your Design
        </BlogCreateDesignBannerInfoTitle>
        <BlogCreateDesignBannerInfoDescription>
          Design your dream home at your fingertips
        </BlogCreateDesignBannerInfoDescription>
        <CreateDesignButton
          onClick={() => {
            logEvent('start_your_design_click', {})
          }}
          href="http://decormatters.app.link/blog"
        >
          <span>Let's Go</span>
        </CreateDesignButton>
      </BlogCreateDesignBannerInfo>
    </BlogCreateDesignBannerContainer>
  )
}
